<template>
    <div class="screen3">
        <div class="item" :class="show ? 'item-checked' : ''" @click="change_screen(type)">{{ title }}<img src="../../assets/arrow  down@2x.png" alt="" /></div>
        <div :class="isCheckbox ? 'secondary-list2' : 'secondary-list1'" v-if="show">
            <div class="all" v-if="!isCheckbox && !banCheckbox" :class="isAll ? 'item2' : 'item1'" @click="checked(all)">
                全部
            </div>
            <div v-for="(item, index) in list" :key="index" :class="isChecked({ item, index }) ? 'item2' : 'item1'" @click="checked({ item, index })">
                {{ item.name }}
            </div>
            <div class="button checkbox" @click="checkboxSwitch()" v-if="list.length > 1 && !banCheckbox">+多选</div>
            <div class="button2-box" v-if="isCheckbox">
                <div class="button2 button2-green" @click="handOk()">确定</div>
                <div class="button2 button2-gray" @click="handCancel()">取消</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'list', 'type', 'show', 'banCheckbox'],
    data() {
        return {
            all: {
                item: {
                    name: '全部',
                    id: 'all'
                },
                index: ''
            },
            showMoreButton: false, //是否显示更多按钮
            isMore: false, //是否显示更多
            isCheckbox: false, //是否是多选状态
            itemList_cache: {},
            itemList: {},
            isAll: false
        };
    },
    watch: {
        list: {
            handler(val, oval) {
                setTimeout(() => {
                    console.log(this.$refs.listBox.offsetHeight);
                    this.showMoreButton = this.$refs.listBox.offsetHeight > 40;
                }, 100);
                this.itemList = [];
                for (let index = 0; index < val.length; index++) {
                    this.itemList[index] = false;
                }
                this.itemList_cache = this.copy(this.itemList);
            },
            deep: true, //是否深度监听
            immediate: true //是否监听初始
        }
    },
    methods: {
        change_screen() {
            this.$emit('change', this.type);
        },
        checkboxSwitch() {
            this.itemList_cache = this.copy(this.itemList);
            this.isAll = false;
            this.isCheckbox = !this.isCheckbox;
        },
        checked({ item, index }) {
            if (this.isCheckbox) {
                this.$set(this.itemList_cache, index, !this.itemList_cache[index]);
                // this.itemList[index] = !this.itemList[index];
                console.log(this.itemList[index]);
            } else {
                for (let index = 0; index < this.list.length; index++) {
                    this.itemList[index] = false;
                }
                this.isAll = false;
                if (index === '') {
                    this.isAll = !this.isAll;
                } else {
                    this.$set(this.itemList, index, !this.itemList[index]);
                }

                // if (this.isChecked({ item, index })) {
                //     this.item = {};
                // } else {
                // this.item = item;
                this.handOk();
                // }
            }
        },
        isChecked({ item, index }) {
            // debugger;
            if (this.isCheckbox) {
                return this.itemList_cache[index];
            } else {
                return this.itemList[index];
            }
        },
        handOk() {
            if (this.isAll) {
                this.$emit('checked', [], this.type);
            } else {
                let checklist = [];
                if (this.isCheckbox) {
                    this.itemList = this.copy(this.itemList_cache);
                    for (let index = 0; index < this.list.length; index++) {
                        if (this.itemList[index]) {
                            checklist.push(this.list[index]);
                        }
                    }
                    this.isCheckbox = false;
                } else {
                    for (let index = 0; index < this.list.length; index++) {
                        if (this.itemList[index]) {
                            checklist.push(this.list[index]);
                        }
                    }
                }
                this.$emit('checked', checklist, this.type);
            }
            this.$emit('change', this.type);
        },
        handCancel() {
            this.itemList_cache = this.copy(this.itemList);
            this.isCheckbox = false;
        },
        copy(obj) {
            const src = JSON.stringify(obj);
            return JSON.parse(src);
        }
    }
};
</script>

<style lang="less" scoped>
.screen3 {
    display: flex;
    .item {
        margin-right: 20px;
        margin-bottom: 10px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 20px;
        padding: 0 7px;
        border: 1px solid #ede9e9;
        cursor: default;
        &:hover {
            color: #2b9a34;
        }
        img {
            width: 9px;
            height: 5px;
            margin: auto 0 auto 5px;
        }
        color: #333333;
        &-checked {
            position: relative;
            z-index: 11;
            background: #ffffff;
            border: 1px solid #2b9a34;
            border-bottom: 0;
            img {
                transform: rotate(180deg);
            }
        }
        // }
    }
    .secondary-list1 {
        display: flex;
        position: absolute;
        top: 31px;
        left: 0;
        width: 1200px;
        border: 1px solid #2b9a34;
        padding: 15px 72px 0 20px;
        background: #ffffff;
        flex-wrap: wrap;
        z-index: 10;
        .item1,
        .item2 {
            margin-right: 20px;
            margin-bottom: 10px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 20px;
            cursor: default;
            &:hover {
                color: #2b9a34;
            }
        }
        .item1 {
            color: #333333;
        }
        .item2 {
            color: #2b9a34;
        }
        .checkbox {
            position: absolute;
            top: 10px;
            right: 12px;
            width: 50px;
            height: 24px;
            border: 1px solid #ede9e9;
            text-align: center;
        }
    }
    .secondary-list2 {
        display: flex;
        position: absolute;
        top: 31px;
        left: 0;
        width: 1200px;
        background: #ffffff;
        border: 1px solid #2b9a34;
        padding: 15px 72px 0 20px;
        background: #ffffff;
        flex-wrap: wrap;
        z-index: 10;
        .item1,
        .item2 {
            margin-right: 20px;
            margin-bottom: 10px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 20px;
            cursor: default;
            display: flex;
            align-items: center;
        }
        .item1 {
            color: #333333;
        }
        .item2 {
            color: #2b9a34;
        }
        .item1::before {
            content: '';
            display: block;
            width: 14px;
            color: #333333;

            height: 14px;
            background: #ffffff;
            border-radius: 1px;
            border: 1px solid #d9d9d9;
            margin-right: 6px;
        }
        .item2::before {
            content: '';
            display: block;

            color: #2b9a34;
            width: 14px;
            height: 14px;
            background-image: url('../../assets/checkin@2x.png');
            border-radius: 1px;
            margin-right: 6px;
            background-size: 100%;
        }
        .checkbox {
            position: absolute;
            top: 10px;
            right: 12px;
            width: 50px;
            height: 24px;
            border: 1px solid #ede9e9;
            text-align: center;
        }
    }
}
.button2-box {
    display: flex;
    justify-content: center;
    width: 1200px;
    position: relative;
    right: 100px;
    .button2 {
        width: 50px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        margin-bottom: 10px;
        &-green {
            color: #ffffff;
            background: #2b9a34;
            margin-right: 20px;
        }
        &-gray {
            background: #f2f2f2;
            border: 1px solid #ede9e9;
            color: #333333;
        }
    }
}
div {
    cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/productList/screen2_2.vue